/**
 * localStorage存储
 */
export default class Storage {

    /**
     * 往缓存中添加数据
     * @param key 要存入的数据名称
     * @param value 具体的数据
     */
    public static add(key: string, value: any): void {
        localStorage.setItem(key, JSON.stringify(value));
    }

    /**
     * 移除一条数据
     * @param key 要删除的数据key值
     */
    public static remove(key: string): void {
        localStorage.removeItem(key);
    }

    /**
     * 获取一条数据
     * @param key 要获取的数据key值
     * @returns 
     */
    public static get(key: string): any {
        if (localStorage.getItem(key)) {
            return JSON.parse(localStorage.getItem(key) as string)
        } else {
            return null
        }
    }

    /**
     * 清空缓存
     */
    public static clear(): void {
        localStorage.clear();
    }


}